import visit from 'unist-util-visit';
import { TextAnalysis, TextAnalysisCategory, TextAnalysisResult } from '../SermonAnalyzer';

export default function SentenceLength() {
    const maxSentenceWordCount = 20;

    let totalSentanceCount:number = 0;
    let hardSentences:number = 0;

    return transformer
    
    function transformer(tree: any, file: any) {
        
        visit(tree, 'SentenceNode', gather)
        
        function gather(sentence: any) {
            
            totalSentanceCount++;
            let sentenceWordCount = 0;

            visit(sentence, 'WordNode', countWords)

            if(sentenceWordCount >= maxSentenceWordCount){
                hardSentences++;
            };

            return visit.SKIP
            
            function countWords(node: any) {
                sentenceWordCount++;
            }
        }
    
        if(totalSentanceCount === 0){
            return;
        }

        let sentenceLength = getHardSentenceText(Math.round((hardSentences / totalSentanceCount) * 100));

        if(sentenceLength.result === TextAnalysisResult.improvement){
            file.improvements.push(sentenceLength);
        } else {
            file.goodResults.push(sentenceLength);
        }
    }

    function getHardSentenceText (percentage:number){
        let result:TextAnalysis = {title: TextAnalysisCategory.sentence_length, displayText: "", helperText: "Percentage based on number of complete sentences containing 20 or more words"};
        if (percentage > 25) {
            result.displayText = `It looks like ${percentage}% of your sentences are longer than expected. We recommend keeping sentences short and to the point. To improve your sermon, write sentences with fewer than 20 words.`;
            result.result = TextAnalysisResult.improvement;
        } else {
            result.displayText = "Congrats, your average sentence length looks perfect.";
            result.result = TextAnalysisResult.goodResult;
        }
        return result;
    }
}





